export default "__VITE_ASSET__CRHuc$ol__"